import { Check, Image as ImageIcon, Loader2, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { ImageState } from './use-image'

interface ImageBubbleProps {
  state: ImageState
  onDismiss: () => void
}

export function ImageBubble({ state, onDismiss }: ImageBubbleProps) {
  const isDone = state.status === 'done'
  const isError = state.status === 'error' || !!state.error

  return (
    <div
      className={cn(
        'rounded-lg border bg-card px-4 py-3 text-sm shadow-sm',
        isError && 'border-destructive/40',
      )}
    >
      <div className="mb-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {state.isRunning ? (
            <Loader2 className="h-4 w-4 animate-spin text-accent" />
          ) : isError ? (
            <X className="h-4 w-4 text-destructive" />
          ) : (
            <Check className="h-4 w-4 text-brand-success" />
          )}
          <ImageIcon className="h-4 w-4 text-muted-foreground" />
          <span className="font-semibold">Bild-Generierung</span>
          {state.model && (
            <span className="rounded bg-muted px-1.5 py-0.5 font-mono text-[11px] text-muted-foreground">
              {state.model}
            </span>
          )}
        </div>
        <Button variant="ghost" size="sm" onClick={onDismiss} className="h-6 px-2">
          <X className="h-3.5 w-3.5" />
        </Button>
      </div>

      {state.detail && (
        <p className="mb-2 text-xs text-muted-foreground">
          {state.status} — {state.detail}
        </p>
      )}

      {state.result?.storage_url && isDone && (
        <div className="space-y-2">
          <div className="overflow-hidden rounded border border-border bg-background">
            <img
              src={state.result.storage_url}
              alt="Generated"
              className="max-h-[420px] w-full object-contain"
            />
          </div>
          <p className="font-mono text-[11px] text-muted-foreground">{state.result.vault_path}</p>
        </div>
      )}

      {state.error && <p className="text-xs text-destructive">{state.error}</p>}
    </div>
  )
}
